import {
    loadAssociationFields,
    createOrUpdate,
    remove,
} from 'src/repositories/debt.repository';
import { loadErrors } from 'src/repositories/importer.repository';
import { getBanks } from 'src/repositories/bank-account.repository';
import { CancelToken } from 'axios';

export const CREATED_PRODUCT = 'CREATED_PRODUCT';
export const SELECTED_PRODUCT = 'SELECTED_PRODUCT';
export const selectProduct = product => dispatch => dispatch({
    type: SELECTED_PRODUCT,
    payload: product,
});

export const EDITED_PRODUCT_NAME = 'EDITED_PRODUCT_NAME';
export const editProductName = newName => dispatch => dispatch({
    type: EDITED_PRODUCT_NAME,
    payload: newName,
});

export const UPLOADED_DEBTS = 'UPLOADED_DEBTS';
export const uploadSpreadsheet = (
    file,
    progressCallback = () => {},
    cancelCallback = () => {},
) => (dispatch, getState, api) => {
    const formData = new FormData();
    formData.append('file', file);

    return api
        .post('/debts/upload', formData, {
            onUploadProgress: progressCallback,
            headers: { 'content-type': 'multipart/form-data' },
            cancelToken: new CancelToken(cancelCallback),
        })
        .then(res => dispatch({
            type: UPLOADED_DEBTS,
            payload: res.data,
        }));
};

export const DEBTS_FILE_CHANGED = 'DEBTS_FILE_CHANGED';
export const changedDebtsFile = () => dispatch => dispatch({
    type: DEBTS_FILE_CHANGED,
    payload: null,
});

export const CHANGED_MAPPED_FIELDS = 'CHANGED_MAPPED_FIELDS';
export const setMappedFields = mappedFields => dispatch => dispatch({
    type: CHANGED_MAPPED_FIELDS,
    payload: mappedFields,
});

export const PROCESSED_SPREADSHEET = 'PROCESSED_SPREADSHEET';
export const processSpreadsheet = params => (dispatch, getState, api) => api.post('/debts/process', params).then(res => dispatch({
    type: PROCESSED_SPREADSHEET,
    payload: res.data,
}));

export const LIST_BANKS_RETRIEVED = 'LIST_BANKS_RETRIEVED';
export const listBanks = () => dispatch => getBanks().then(({ data }) => dispatch({
    type: LIST_BANKS_RETRIEVED,
    payload: data,
}));

export const SET_SPREADSHEET_FILENAME = 'SET_SPREADSHEET_FILENAME';
export const setSpreadsheetName = name => dispatch => dispatch({
    type: SET_SPREADSHEET_FILENAME,
    payload: name,
});

export const FINISHED_IMPORT = 'FINISHED_IMPORT';
export const finishImport = () => dispatch => dispatch({
    type: FINISHED_IMPORT,
    payload: null,
});

export const FINISHED_MANUAL_IMPORT = 'FINISHED_MANUAL_IMPORT';
export const finishManualImport = () => (dispatch, getState) => {
    const state = getState();
    return dispatch({
        type: FINISHED_MANUAL_IMPORT,
        payload: state.importer.manualDebts,
    });
};

export const LOADED_ASSOCIATION_FIELDS = 'LOADED_ASSOCIATION_FIELDS';
export const loadDebtsAssociationFields = () => dispatch => loadAssociationFields().then(res => dispatch({
    type: LOADED_ASSOCIATION_FIELDS,
    payload: res.data,
}));

export const LOADING_SPREADSHEET_ERRORS = 'LOADING_SPREADSHEET_ERRORS';
export const LOADED_SPREADSHEET_ERRORS = 'LOADED_SPREADSHEET_ERRORS';
export const loadSpreadsheetErrors = params => dispatch => loadErrors(params).then((res) => {
    dispatch({
        type: LOADED_SPREADSHEET_ERRORS,
        payload: res.data,
    });
});

export const CORRECTED_DEBT = 'CORRECTED_DEBT';
export const correctDebt = params => dispatch => createOrUpdate(params).then((res) => {
    dispatch({
        type: CORRECTED_DEBT,
        payload: res.data,
    });
});

export const CREATED_DEBT = 'CREATED_DEBT';
export const createDebt = params => dispatch => createOrUpdate(params).then((res) => {
    dispatch({
        type: CREATED_DEBT,
        payload: res.data.success,
    });
});

export const DEBT_MANUALLY_DELETED = 'DEBT_MANUALLY_DELETED';
export const deleteManuallyDebt = pkDebt => dispatch => remove(pkDebt)
    .then(() => {
        dispatch({
            type: DEBT_MANUALLY_DELETED,
            payload: pkDebt,
        });
    })
    .catch((err) => {
        if (
            err.response
                && err.response.status
                && err.response.status === 404
        ) {
            dispatch({
                type: DEBT_MANUALLY_DELETED,
                payload: pkDebt,
            });
        } else {
            throw err;
        }
    });
